(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15535],{

/***/ 13189:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_PageIntroSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/Figures/index.jsx + 3 modules
var Figures = __webpack_require__(84486);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants/linkType.js
var constants_linkType = __webpack_require__(45177);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./UI/sections/PageIntroSection/utils/useSectionProps.js


/* harmony default export */ function useSectionProps(param) {
    var introSection = param.introSection, section = param.section, type = param.type, handleOnCTAClick = param.handleOnCTAClick;
    var ref = (0,helper/* getDocumentFields */.OA)(section, [
        "title",
        "description",
        "images",
        "contentModules", 
    ]), title = ref.title, description = ref.description, images = ref.images, contentModules = ref.contentModules;
    var image = (0,helper/* getImage */.gJ)(get_default()(images, "[0]", {}));
    var figuresData = contentModules === null || contentModules === void 0 ? void 0 : contentModules.find(function(module) {
        var ref = (0,helper/* getDocumentFields */.OA)(module, [
            "contentModules"
        ]), figures = ref.contentModules;
        return figures;
    });
    var links = contentModules === null || contentModules === void 0 ? void 0 : contentModules.filter(function(module) {
        var ref = (0,helper/* getDocumentFields */.OA)(module, [
            "type", 
        ]), linkType = ref.type;
        return linkType === "button" || linkType === "scroll-to-section";
    });
    return {
        type: type,
        introSection: introSection,
        title: title,
        description: description,
        image: image,
        figuresData: figuresData,
        handleOnCTAClick: handleOnCTAClick,
        links: links
    };
};

// EXTERNAL MODULE: ./UI/sections/PageIntroSection/styles.module.scss
var styles_module = __webpack_require__(33731);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/PageIntroSection/index.jsx














var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Typography = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 59654));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59654)
            ];
        }
    }
});
var Button = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 49105));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49105)
            ];
        }
    }
});
var PageIntroSection = function(props) {
    var ref = useSectionProps(props), type = ref.type, title = ref.title, description = ref.description, image = ref.image, figuresData = ref.figuresData, introSection = ref.introSection, handleOnCTAClickCommon = ref.handleOnCTAClick, links = ref.links;
    // TODO: use rich text instead of splitting
    var descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split("||");
    var handleOnCTAClick = function(param) {
        var linkType = param.linkType, url = param.url;
        return function() {
            if (linkType === constants_linkType/* LINK_TYPE.scrollToSection */.x.scrollToSection) {
                var element = document.getElementById(url);
                window.scrollBy({
                    top: element.getBoundingClientRect().top - constants/* HEADER_HEIGHT */.Mz - 50,
                    behavior: "smooth"
                });
            } else {
                handleOnCTAClickCommon();
            }
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        ref: introSection,
        className: classnames_default()((styles_module_default()).pageIntroSection, (styles_module_default())[type]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default()).pageWrapper,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (styles_module_default()).pageTextContainer,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                    children: title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                        variant: "h1",
                                        size: useTypography/* TYPOGRAPHY_SIZE.headline46 */.y3.headline46,
                                        mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                                        className: (styles_module_default()).pageTitle,
                                        children: title
                                    })
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                    children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map(function(text, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography, {
                                            variant: "p",
                                            className: (styles_module_default()).pageSubtitle,
                                            children: text
                                        }, "paragraph/".concat(index));
                                    })
                                })),
                                (links === null || links === void 0 ? void 0 : links.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default()).buttonWrapper,
                                    children: links === null || links === void 0 ? void 0 : links.map(function(link, index) {
                                        var ref = (0,helper/* getDocumentFields */.OA)(link, [
                                            "buttonTitle",
                                            "url",
                                            "type", 
                                        ]), url = ref.url, buttonTitle = ref.buttonTitle, linkType = ref.type;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button, {
                                                onClick: url && linkType !== constants_linkType/* LINK_TYPE.scrollToSection */.x.scrollToSection ? null : handleOnCTAClick({
                                                    linkType: linkType,
                                                    url: url
                                                }),
                                                className: classnames_default()((styles_module_default()).button, (styles_module_default())["button-".concat(index + 1)]),
                                                href: linkType !== constants_linkType/* LINK_TYPE.scrollToSection */.x.scrollToSection ? url : null,
                                                "data-button": true,
                                                children: buttonTitle
                                            })
                                        }), "".concat(link.url, "-").concat(link.buttonTitle));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                            children: image.url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                                src: image.url,
                                alt: image.alt,
                                className: (styles_module_default()).pageImage,
                                transparent: true,
                                priority: true
                            })
                        }))
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Figures/* Figures */.N, {
                    type: type,
                    figuresData: figuresData
                })
            ]
        })
    });
};
PageIntroSection.defaultProps = {
    introSection: null
};
PageIntroSection.propTypes = {
    section: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired,
    introSection: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var sections_PageIntroSection = (PageIntroSection);


/***/ }),

/***/ 33731:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage___Bapj","cards":"styles_cards__gHk8o","imageWrapper":"styles_imageWrapper__3Hu3q","typeTitle":"styles_typeTitle__bRvFE","greySection":"styles_greySection__Nzrt4","callToAction":"styles_callToAction__ngxRV","threeColumnsCards":"styles_threeColumnsCards__PxzIP","twoColumnsCards":"styles_twoColumnsCards__73XOU","textContent":"styles_textContent__2U90V","pageIntroSection":"styles_pageIntroSection__wrkmV","contentWrapper":"styles_contentWrapper__68TIO","pageWrapper":"styles_pageWrapper__pyXeq","pageTextContainer":"styles_pageTextContainer__avVmC","pageTitle":"styles_pageTitle__KAhQs","pageSubtitle":"styles_pageSubtitle__oJ7jY","pageImage":"styles_pageImage__Gx9l6","buttonWrapper":"styles_buttonWrapper__XCPtE","button":"styles_button__O9HmA","ios-mobile-app-development-services":"styles_ios-mobile-app-development-services__bJ2_L","artificial-intelligence-development-services":"styles_artificial-intelligence-development-services__pBzbl","chat-app-development-company":"styles_chat-app-development-company__NhjVO","devops-development-services":"styles_devops-development-services__m7oR0","enterprise-resource-planning-software-services":"styles_enterprise-resource-planning-software-services__A3QP1","fintech-software-development-services":"styles_fintech-software-development-services__HFXDp","machine-learning-development-services":"styles_machine-learning-development-services__D79ii","mobile-app-development-company":"styles_mobile-app-development-company__lQuHQ","ui-ux-services":"styles_ui-ux-services__GMkez","web-app-development-company":"styles_web-app-development-company__7w1Wy","discovery-phase-services":"styles_discovery-phase-services__w3AFZ","mvp-app-development-company":"styles_mvp-app-development-company__xzQn7","android-mobile-app-development-services":"styles_android-mobile-app-development-services__g9jbX","cloud-based-app-development-services":"styles_cloud-based-app-development-services__cXLhf","cross-platform-development-services":"styles_cross-platform-development-services__MMzcE","data-science-development-company":"styles_data-science-development-company__1iqZG","prototyping-services":"styles_prototyping-services__wiUXP","lending-software-development":"styles_lending-software-development___sSJi","trading-software-development":"styles_trading-software-development__wnuIW","penetration-testing":"styles_penetration-testing__Z6rew","pricing":"styles_pricing__ykbor","e-wallet-app-development":"styles_e-wallet-app-development__LF9TC","banking-software-development-company":"styles_banking-software-development-company___7i6h","delivery-quality-in-yellow":"styles_delivery-quality-in-yellow__GNDyR","crowdfunding-platform-development-company":"styles_crowdfunding-platform-development-company__kBs79","payment-gateway-development-company":"styles_payment-gateway-development-company__neZq8","pwa-development-services":"styles_pwa-development-services__4w4hE","software-quality-assurance-services":"styles_software-quality-assurance-services__dy0fs","billing-software-development-services":"styles_billing-software-development-services__ngnQA","software-development-columbus":"styles_software-development-columbus__WIYDc","software-development-new-orleans":"styles_software-development-new-orleans__WgCSD","software-development-tulsa":"styles_software-development-tulsa__2QzbZ","software-development-minneapolis":"styles_software-development-minneapolis__DYZRk","software-development-miami":"styles_software-development-miami__FYRvG","software-development-washington":"styles_software-development-washington__atTZy","software-development-oklahoma":"styles_software-development-oklahoma__PllOm","software-development-omaha":"styles_software-development-omaha__IAS9z","software-development-nashville":"styles_software-development-nashville__S9H0p","software-development-raleigh":"styles_software-development-raleigh__jqfZx","ai-software-development-services":"styles_ai-software-development-services__tDzeF","computer-vision-services":"styles_computer-vision-services__Xbaou","natural-language-processing-as-a-service":"styles_natural-language-processing-as-a-service__UYc6H","robotic-process-automation-services":"styles_robotic-process-automation-services__i_GK_","button-2":"styles_button-2__mZWTt","generative-AI-services":"styles_generative-AI-services__VkJtY","deep-learning":"styles_deep-learning__4cEQL","ai-chatbot-development-services":"styles_ai-chatbot-development-services__Alubn","software-development-services-for-various-industries":"styles_software-development-services-for-various-industries__YOeeN","ai-staff-augmentation-services":"styles_ai-staff-augmentation-services__SkALM","ai-consulting-services":"styles_ai-consulting-services__T8RM3","software-development-services-for-startups":"styles_software-development-services-for-startups__hfe__","logistics-software-development-services":"styles_logistics-software-development-services__vPnpV","e-commerce-development":"styles_e-commerce-development__GPfWK","travel-and-hospitality-software-development":"styles_travel-and-hospitality-software-development__EicZ_","educational-software-development-services":"styles_educational-software-development-services__9eovz","entertainment-software-development-services":"styles_entertainment-software-development-services__Eu1K6","healthcare-software-development-services":"styles_healthcare-software-development-services__yAIGF","software-development-engagement-models":"styles_software-development-engagement-models__B7L8e"};

/***/ })

}]);